import angular from 'angular';
import uiRouter from 'angular-ui-router';
import managerAcceptAllComponent from './managerAcceptAll.component';

let managerAcceptAllModule = angular.module('managerAcceptAll', [
  uiRouter
])

.component('managerAcceptAll', managerAcceptAllComponent)

.name;

export default managerAcceptAllModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestModal/managerAcceptAll/managerAcceptAll.js